import type { ReactNode } from 'react';

import { FhirRendererProvider } from '@eluve/fhir-renderer';

import { useMedplum } from './MedplumProvider';

/**
 * Bridges the Medplum session into the fhir-renderer SDK: the renderer
 * provider carries the default component registry plus the tenant's FHIR
 * GraphQL Apollo client, so anything below can query and render FHIR
 * resources without per-component wiring.
 */
export const MedplumFhirRendererProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { fhirClient } = useMedplum();
  return (
    <FhirRendererProvider client={fhirClient ?? undefined}>
      {children}
    </FhirRendererProvider>
  );
};
